let ajaxinateInstance

const initAjaxinate = () => {
  if (ajaxinateInstance) {
    ajaxinateInstance.removeScrollListener();
  }
  ajaxinateInstance = new Ajaxinate({
    container: '#product-grid',
    pagination: '#infinity-pagination',
    saveHistory: true,
    scrollHistory: true,
    productCard: '.custom-product',
  });
}

window.resetPaginationState = initAjaxinate;

document.addEventListener("DOMContentLoaded", initAjaxinate);